module.exports = __webpack_public_path__ + "media/images/AllCare-Explorer-60026c13d4d27000511759d0bfceb230.svg";